import ArtistDetails from "./ArtistDetails";
export default ArtistDetails;
